module.exports = __webpack_public_path__ + "img/4_26@3x.dcb02333.png";